import * as React from "react";

import type { SortOption } from "@/components/sortDropdown";
import { DriveSearch } from "@/views/drive/search";

interface Props {
  folderId?: string;
  currentSort: SortOption;
  onSortChange: (sort: SortOption) => void;
}

export const DriveToolbar: React.FC<Props> = ({ folderId, currentSort, onSortChange }) => (
  <DriveSearch folderId={folderId} currentSort={currentSort} onSortChange={onSortChange} />
);
